import React from 'react'
import PropTypes from 'prop-types'

import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { addTestAutomationClassName } from 'utils/misc'
import CircularProgress from '@material-ui/core/CircularProgress'

import ButtonWithImage from 'components/atoms/buttons/ButtonWithImage'
import EmptyStateButton from 'components/atoms/buttons/EmptyStateButton'

const styles = theme => ({
  root: {
    position: 'relative',
    paddingTop: theme.spacing(4),
    margin: `${theme.spacing(2)}px 0`,
  },
  loader: {
    height: 108,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  list: {
    marginTop: theme.spacing(1),
    animation: 'fadeIn .3s ease',
  },
  emptyMessage: {
    top: 0,
    fontSize: 14,
    position: 'absolute',
    marginBottom: theme.spacing(2),
    color: theme.palette.disabled.main,
  },
  organisations: {
    minHeight: 100,
    maxHeight: 250,
    overflowY: 'auto',
    padding: '6px 2px 0px',
  },
})

const OrganisationList = ({
  classes, data, onItemPress, onCreatePress
}) => (
  <section className={classes.root}>
    {data && Object.keys(data).length === 0 && (
      <Typography className={classes.emptyMessage}>
          You don't belong to any projects
      </Typography>
    )}
    <EmptyStateButton
      label="Create a project"
      onPress={onCreatePress}
      className={addTestAutomationClassName('qa-accounthome-button-createorganisation')}
    />
    {data ? (
      <div className={classes.list}>
        <div className={classes.organisations}>
          {Object.keys(data).map((item, index) => {
            const organisation = data[item]
            return (
              <ButtonWithImage
                key={index}
                data={organisation}
                onPress={onItemPress}
                uuid={organisation.uuid}
                text={organisation.name}
                image={organisation.imageUrl}
                className={addTestAutomationClassName(`qa-accounthome-button-organisation-${index + 1}`)}
              />
            )
          })}
        </div>
      </div>
    ) : (
      <div className={classes.loader}>
        <CircularProgress size={30} />
      </div>
    )}
  </section>
)

OrganisationList.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  classes: PropTypes.object,
  onItemPress: PropTypes.func,
  onCreatePress: PropTypes.func,
}

export default withStyles(styles)(OrganisationList)



// WEBPACK FOOTER //
// ./src/components/molecules/OrganisationList.js